<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { getCurrentInstance, onMounted } from 'vue';

import Details from '@/components/mode-details/Details.vue';
import { i18n } from '@/shared-instance';
import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore';

const props = defineProps<{
  productId: string;
  noWidgetTaxoId?: string;
}>();

i18n.install(getCurrentInstance()!.appContext.app);

const globalConfigurationStore = useGlobalConfigurationStore();
const { globalConfiguration } = storeToRefs(globalConfigurationStore);

onMounted(async () => {
  if (!globalConfiguration.value || !globalConfiguration.value.apikey)
    throw new Error('global configuration for product details is missing');
  if (!props.productId) {
    throw new Error('productId for product details component is missing');
  }
});
</script>

<template>
  <Details
    :product-id="props.productId"
    :no-widget-taxo-id="props.noWidgetTaxoId ?? null"
    :prefix-url="globalConfiguration?.prefixUrl ?? null"
  />
</template>
